var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forecast"},[_c('ul',{staticClass:"list pa3 mt2 mb0"},_vm._l((_vm.forecast),function(fcItem){return _c('ForecastItem',{key:fcItem.time,attrs:{"forecastItem":fcItem}})}))])}
var staticRenderFns = []

export { render, staticRenderFns }